import { HttpErrorResponse } from "@angular/common/http";
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from "@angular/core";
import { Campo } from "src/app/models/coleta";
import { AppFlowService } from "src/app/services/app-flow.service";
import { FacecaptchaService } from "../../service/facecaptcha.service";

@Component({
  selector: "app-image-capture-oiti-document",
  templateUrl: "./image-capture-oiti-document.component.html",
  styleUrls: ["./image-capture-oiti-document.component.scss"],
})
export class ImageCaptureOitiDocumentComponent {
  @Input() campo: Campo = {};

  @Output()
  imageCapture = new EventEmitter<{ image: { url: string; type: string } }[]>();
  @Output()
  captureError = new EventEmitter<string>();
  @Output() cancel = new EventEmitter();

  streams: any;
  appkey = "";
  snapsCaptures: { data: string; type: string }[] = [];
  snapTempDOM: any = "";
  message = "";

  showTypeCapture = true;
  multiCapture = false;
  showIniciar = false;
  showUpload = false;
  isLoaded = false;
  rotateCamera = false;
  btnControllers = false;
  processing = false;
  indexTempSnap = -1;
  showDesktop = false;
  uploadRequest = false;
  uploadResp = true;

  constructor(
    private faceCaptchaService: FacecaptchaService,
    private appFlowService: AppFlowService
  ) {}

  ngOnInit() {
    this.extrairDadosAppKey();
    this.showDesktop = !this.isMobile();
    this.setTypeCapture(this.selecionaTipoCamera());
  }

  ngOnDestroy() {
    this.stopCameraStreams();
  }

  @HostListener("window:resize", ["$event"])
  onResize(event?: any) {
    if (
      !this.showTypeCapture &&
      !this.processing &&
      this.multiCapture &&
      !this.showDesktop
    ) {
      this.stopCameraStreams();
      if (window.innerWidth > window.innerHeight) {
        this.rotateCamera = false;
        this.message = "";
        if (!this.btnControllers && !this.showUpload) {
          this.startCamera();
        }
      } else {
        this.rotateCamera = true;
        this.message = "";
        this.isLoaded = false;
      }
    } else if (
      !this.showTypeCapture &&
      !this.processing &&
      !this.multiCapture &&
      !this.showDesktop
    ) {
      if (
        window.innerWidth > window.innerHeight &&
        window.innerWidth < 1440 &&
        !this.showDesktop
      ) {
        this.rotateCamera = true;
        this.message = "";
        this.isLoaded = false;
      } else {
        this.rotateCamera = false;
        this.message = "";
        if (!this.btnControllers && !this.showUpload) {
          this.startCamera();
        }
      }
    } else if (this.showDesktop) {
      this.rotateCamera = false;
      this.message = "";
      if (!this.btnControllers && !this.showUpload) {
        this.startCamera();
      }
    } else if (this.processing) {
      if (this.multiCapture) {
        if (window.innerWidth < window.innerHeight) {
          this.rotateCamera = true;
        } else {
          this.rotateCamera = false;
        }
      } else {
        if (!this.showDesktop) {
          if (window.innerWidth < window.innerHeight) {
            this.rotateCamera = false;
          } else {
            this.rotateCamera = true;
          }
        }
      }
    }
  }

  // Volta para tela de seleção da quantidade de fotos à capturar
  backSetTypeCapture() {
    this.uploadRequest = false;
    this.btnControllers = false;
    this.showTypeCapture = true;
    this.showIniciar = false;
    this.showUpload = false;
    this.snapsCaptures = [];
    this.stopCameraStreams();
  }

  // Seleciona a quantidade de fotos que vai capturar
  setTypeCapture(type: any) {
    if (type === 1) {
      this.multiCapture = false;
      this.showTypeCapture = false;
      this.onResize();
    } else {
      this.multiCapture = true;
      this.showTypeCapture = false;
      this.onResize();
    }
  }

  // Abertura da câmera
  startCamera() {
    if (this.multiCapture) {
      if (this.indexTempSnap !== -1) {
        this.message =
          this.indexTempSnap === 1
            ? "Centralize o verso do documento"
            : "Centralize a frente do documento";
      } else {
        this.message =
          this.snapsCaptures.length === 0
            ? "Centralize a frente do documento"
            : "Centralize o verso do documento";
      }
    } else {
      this.message = "Centralize o documento";
    }
    this.showIniciar = false;
    this.isLoaded = true;
    this.processing = true;
    setTimeout(() => {
      this.showIniciar = true;
      this.isLoaded = false;
      this.message = "";
      this.processing = false;
    }, 300);

    (navigator as any).getUserMedia = (
      (navigator as any).getUserMedia ||
      (navigator as any).webkitGetUserMedia ||
      (navigator as any).mozGetUserMedia ||
      (navigator as any).msGetUserMedia ||
      (navigator as any).mediaDevices.getUserMedia
    ) as any;
    // ajusta as configurações de video
    const constraints: any = {
      audio: false,
      video: {
        facingMode: "environment",
        width: { exact: 640 },
        height: { exact: 480 },
      },
    };

    // se mobile, ajusta configurações de video para mobile
    if (this.isMobile()) {
      constraints.video = {
        width: { exact: 1280 },
        height: { exact: 720 },
        facingMode: "environment",
      };
    }

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then((stream) => this.handleStream(stream))
      .catch((err) => {
        console.log("No camera! " + err);
      });

    // verifica suporte a getUserMedia
    //if (navigator.getUserMedia) {
    //  navigator.mediaDevices
    //    .getUserMedia(constraints)
    //    .then((stream) => this.handleStream(stream))
    //    .catch((err) => {
    //      console.log('No camera! ' + err);
    //    });
    //} else {
    //  console.log('getUserMedia not supported');
    //}
  }

  private handleStream(stream: any) {
    const video: any = document.getElementById("player");

    video.setAttribute("autoplay", "");
    video.setAttribute("muted", "");
    video.setAttribute("playsinline", "");

    video.srcObject = stream;
    this.streams = stream.getVideoTracks();
  }

  // Fecha a câmera
  stopCameraStreams() {
    if (this.streams) {
      this.streams.forEach((stream: any) => {
        stream.stop();
      });
      this.streams = null;
    }
  }

  async startCapture() {
    this.processing = true;
    this.snapCapture();
    this.message = "Processando";
    this.showIniciar = false;
    this.isLoaded = true;
    this.stopCameraStreams();
    setTimeout(() => {
      this.message = "";
      this.btnControllers = true;
      this.isLoaded = false;
      this.processing = false;
    }, 300);
  }

  // Limpa as listar e reinicia a Câmera
  resetSnap() {
    this.snapTempDOM = "";
    this.btnControllers = false;
    if (this.multiCapture) {
      if (this.snapsCaptures.length < 2) {
        this.startCamera();
      } else {
        this.showUpload = true;
        this.stopCameraStreams();
      }
    } else {
      if (this.snapsCaptures.length < 1) {
        this.startCamera();
      } else {
        this.showUpload = true;
        this.stopCameraStreams();
      }
    }
  }

  // captura imagem para validação do usuário
  snapCapture() {
    this.snapTempDOM = this.snap();
  }

  // prepara captura de imagem
  snapTick() {
    // Adiciona as fotos nas listas
    if (this.indexTempSnap !== -1) {
      this.snapsCaptures.splice(this.indexTempSnap, 0, {
        data: this.snapTempDOM,
        type: this.selecionaTipoDocumento(this.campo, "frente"),
      });
    } else {
      this.snapsCaptures.push({
        data: this.snapTempDOM,
        type:
          this.snapsCaptures.length === 0
            ? this.selecionaTipoDocumento(this.campo, "frente")
            : this.selecionaTipoDocumento(this.campo, "verso"),
      });
    }
    this.indexTempSnap = -1;
    // Limpa as listas e reinicia a câmera
    this.resetSnap();
  }

  // captura imagem da câmera
  snap() {
    const video: any = document.getElementById("player");
    const canvas: any = document.getElementById("fc_canvas");
    const ctx = canvas.getContext("2d");

    let ratio = video.videoWidth / video.videoHeight;
    let widthReal = 0;
    let heightReal = 0;
    let startX = 0;
    let startY = 0;

    if (ratio >= 1 && !this.showDesktop) {
      ctx.canvas.width = 1280;
      ctx.canvas.height = 768;
      widthReal = video.videoWidth;
      heightReal = video.videoHeight;
      startX = 0;
      startY = 0;
    } else {
      // retrato
      ctx.canvas.width = 640;
      ctx.canvas.height = 960;
      ratio = video.videoHeight / video.videoWidth;
      // verifica proporção
      if (ratio > 1.5) {
        widthReal = video.videoWidth;
        heightReal = video.videoHeight;
        startX = 0;
        startY = 0;
      } else {
        widthReal = video.videoHeight / 1.5;
        heightReal = video.videoHeight;
        startX = (video.videoWidth - widthReal) / 2;
        startY = 0;
      }
    }

    // crop image video
    ctx.drawImage(
      video,
      startX,
      startY,
      widthReal,
      heightReal,
      0,
      0,
      ctx.canvas.width,
      ctx.canvas.height
    );

    const img = new Image();
    img.src = canvas.toDataURL("image/jpeg");
    return img.src;
  }

  // remove imagem das listas
  removeSnapFromLists(index: any) {
    this.indexTempSnap = index;
    this.snapsCaptures.splice(index, 1);
    this.showUpload = false;
    this.resetSnap();
  }

  // Envia as fotos e finaliza o upload de imagens
  uploadPictures() {
    this.isLoaded = true;
    const snapsSend = this.snapsCaptures.map((snap) =>
      snap.data.replace("data:image/jpeg;base64,", "")
    );
    let images: { image: { url: string; type: string } }[] = [];

    this.snapsCaptures.forEach((snap) =>
      images.push({
        image: {
          url: snap.data.replace("data:image/jpeg;base64,", ""),
          type: snap.type,
        },
      })
    );

    this.faceCaptchaService.sendDocument(this.appkey, snapsSend).subscribe(
      (response) => {
        this.isLoaded = false;
        this.uploadRequest = true;
        this.uploadResp = true;
        this.imageCapture.emit(images);

        //Transmite a mensagem via observable para atualizacao das imagens no background dos componentes
        this.appFlowService.reloadComponent.next(images);
      },
      (error: HttpErrorResponse) => {
        this.isLoaded = false;
        this.backSetTypeCapture();
        console.log(error);

        this.captureError.emit(this.trataRetorno(error));
      }
    );

  }

  private isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  }

  voltar(event: Event) {
    this.cancel.emit(event);
  }

  //Pega os dados da appKey do form app state e atribui a variavel que será passada na request.
  extrairDadosAppKey() {
    const properties: any = this.appFlowService.getFormValues();

    if (properties.hasOwnProperty("biometria.consulta")){
      const biometria = JSON.parse(properties["biometria.consulta"]);

      if(biometria.hasOwnProperty("id")) this.appkey = biometria["id"];
    }
     
  }

  //Regex para dar replace na ultima palavra do documento. Ex: pessoa.cnh.frente daria replace no .frente dependendo d parametro type.
  selecionaTipoDocumento(campo: Campo, type: string) {
    return campo.codigo?.replace(/(\w+)$/, type)
      ? campo.codigo?.replace(/(\w+)$/, type)
      : "";
  }

  selecionaTipoCamera(){
    switch(this.campo.codigo){
      case 'pessoa.documento.identidadeMilitar.frente': return 1;
      default: return 2;
    }
  }

  trataRetorno(error: HttpErrorResponse): string {
    switch (error.status) {
      case 401:
        return "Tempo para a captura de fotos excedido. Favor refazer o processo de selfie/documentos.";
      case 400:
        return "Documento não encontrado, voltar para captura de documentos.";
      default:
        return "Erro genérico. Favor contatar o suporte.";
    }
  }
}
